import { render, staticRenderFns } from "./ProfileSection.vue?vue&type=template&id=65ebf86f&scoped=true&"
import script from "./ProfileSection.vue?vue&type=script&lang=js&"
export * from "./ProfileSection.vue?vue&type=script&lang=js&"
import style0 from "./ProfileSection.vue?vue&type=style&index=0&id=65ebf86f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ebf86f",
  null
  
)

export default component.exports